import { render, staticRenderFns } from "./instructList.vue?vue&type=template&id=1ca44383&"
import script from "./instructList.vue?vue&type=script&lang=js&"
export * from "./instructList.vue?vue&type=script&lang=js&"
import style0 from "./instructList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca44383')) {
      api.createRecord('1ca44383', component.options)
    } else {
      api.reload('1ca44383', component.options)
    }
    module.hot.accept("./instructList.vue?vue&type=template&id=1ca44383&", function () {
      api.rerender('1ca44383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/instruct/instructList.vue"
export default component.exports